import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { getSetting } from '../helpers/Settings';

const LoginGoogleButton = ({ handleGoogleSignIn }) => {
  useEffect(() => {
    const handleCredentialResponse = (response) => {
      const { type, data } = response.data;
      if (type === 'googleSignIn') {
        handleGoogleSignIn(data.credential);
      }
    };

    window.addEventListener('message', handleCredentialResponse);
    return () => {
      window.removeEventListener('message', handleCredentialResponse);
    };
  }, [handleGoogleSignIn]);

  return (
    <div className={`login-google login-google-${getSetting('google_login_position')}`}>
      <iframe
        className="google-sign-in-iframe"
        title="Google Sign-In"
        src={`https://${process.env.MIX_GOOGLE_AUTH_DOMAIN}/google-login-button${process.env.MIX_ENV === 'local' ? '.html' : ''}`}
        allow="identity-credentials-get"
      />
    </div>
  );
};

LoginGoogleButton.propTypes = {
  handleGoogleSignIn: PropTypes.func.isRequired,
};

export default LoginGoogleButton;
